import * as React from 'react';

// Chat Actions
export const CHAT_ACTIONS = {
  ADD_MESSAGE: 'CHAT_ADD_MESSAGE',
  SET_LOADING: 'CHAT_SET_LOADING',
  CLEAR_CHAT: 'CHAT_CLEAR_CHAT',
  TOGGLE_TOOL_CALL: 'CHAT_TOGGLE_TOOL_CALL',
  SET_EXECUTION_LAYERS: 'CHAT_SET_EXECUTION_LAYERS',
  UPDATE_LAYER_STATUS: 'CHAT_UPDATE_LAYER_STATUS',
  UPDATE_TOOL_CALL_STATUS: 'CHAT_UPDATE_TOOL_CALL_STATUS',
  SET_CURRENT_LAYER: 'CHAT_SET_CURRENT_LAYER',
};

export interface Message {
  content: string;
  sender: 'user' | 'ai' | 'toolCall';
  timestamp: Date;
  formattedContent?: any;
  isExpanded?: boolean;
}

export interface ToolCall {
  name: string;
  timestamp: Date;
  isExpanded?: boolean;
  sender: 'toolCall';
  content: any;
  status?: 'pending' | 'running' | 'completed' | 'failed';
  error?: string;
  layerIndex?: number;
  totalLayers?: number;
  id?: string;
  startTime?: Date;
  endTime?: Date;
  progress?: number;
}

export interface ExecutionLayer {
  layerIndex: number;
  agents: Array<{
    agent: string;
    status: 'pending' | 'running' | 'completed' | 'failed';
    result?: any;
    error?: string;
    startTime?: Date;
    endTime?: Date;
  }>;
  status: 'pending' | 'running' | 'completed' | 'failed';
  startTime?: Date;
  endTime?: Date;
}

// Action creators
export const addMessage = (message: Message | ToolCall) => ({
  type: CHAT_ACTIONS.ADD_MESSAGE,
  payload: message,
});

export const setLoading = (isLoading: boolean) => ({
  type: CHAT_ACTIONS.SET_LOADING,
  payload: isLoading,
});

export const clearChat = () => ({
  type: CHAT_ACTIONS.CLEAR_CHAT,
});

export const toggleToolCall = (messageIndex: number) => ({
  type: CHAT_ACTIONS.TOGGLE_TOOL_CALL,
  payload: messageIndex,
});

export const setExecutionLayers = (layers: ExecutionLayer[]) => ({
  type: CHAT_ACTIONS.SET_EXECUTION_LAYERS,
  payload: layers,
});

export const updateLayerStatus = (layerIndex: number, status: ExecutionLayer['status'], results?: any) => ({
  type: CHAT_ACTIONS.UPDATE_LAYER_STATUS,
  payload: { layerIndex, status, results },
});

export const updateToolCallStatus = (toolCallId: string, status: ToolCall['status'], content?: any, error?: string) => ({
  type: CHAT_ACTIONS.UPDATE_TOOL_CALL_STATUS,
  payload: { toolCallId, status, content, error },
});

export const setCurrentLayer = (layerIndex: number) => ({
  type: CHAT_ACTIONS.SET_CURRENT_LAYER,
  payload: layerIndex,
}); 